import { PortalTemplate } from "../../template/portal/default-template";
import { TtzkPortalR } from "./route";

export const PortalHome = () => {
  return (
    <PortalTemplate
      breadcrumbs={[
        { to: TtzkPortalR.Home.link({}), title: "Graffer ポータル" },
      ]}
    >
      <div className="content">
        <h1>Graffer ポータル</h1>
        <p>Graffer ポータルの管理画面です。</p>
        <p>画面左のメニューから実行したい操作を選択してください。</p>
      </div>
    </PortalTemplate>
  );
};
